import { connect } from 'react-redux';

// Actions
import {
  clear,
  loadSearchTerms,
  search,
  updateSearchTermsError,
} from '../actions/multiSearch';

// Components
import MultiSearch from '../components/MultiSearch';

export default connect(state => ({
  betaFeatures: state.user.betaFeatures,
  isEditable: state.header.multiSearch.isEditable,
  searchTerms: state.header.multiSearch.searchTerms,
  error: state.header.multiSearch.error,
}), {
  search,
  clear,
  loadSearchTerms,
  updateSearchTermsError,
})(MultiSearch);
